import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export async function assignSalesAgent(
	salesAgentId,
	leadId,
	assignedId,
	isCobroker,
	setLoading
) {
	if (salesAgentId !== assignedId) {
		var originalSalesAgentRef = firebaseRef.ref(
			'/kavtek_purchasers/' +
				PROJECT_CODE.projectCode +
				'/' +
				salesAgentId +
				'/' +
				leadId
		);
		var destinationSalesAgentRef = firebaseRef.ref(
			'/kavtek_purchasers/' +
				PROJECT_CODE.projectCode +
				'/' +
				assignedId +
				'/' +
				leadId
		);

		console.log('assignSalesAgent', salesAgentId, leadId, assignedId);

		//copy object

		//if assignedId !== cobroker and leadId.cobroker not null, then delete cobroker

		originalSalesAgentRef.once('value', (snapshot) => {
			destinationSalesAgentRef.update(snapshot.val(), (error) => {
				if (error) {
					console.error('Could not copy data.', error);
				} else {
					originalSalesAgentRef.remove();
				}
			});
		});

		if (isCobroker) {
			destinationSalesAgentRef.child('cobroker').remove();
		}

		//change the assigned agent
		destinationSalesAgentRef
			.update({
				leadToSalesAgent: assignedId,
			})
			.then(() => {
				setLoading(false);
			});
	}
}
